export default {
  title: "Untitled",
  thumbnail: null,
  workflow_info: null,
  nodes: [],
  linked_nodes: [],
  current_node: 0,
};
